function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.913 8.854a2.91 2.91 0 00-1.437 5.443 2.907 2.907 0 003.516-.503l5.308 3.063c-.07.237-.109.481-.117.728a2.908 2.908 0 005.6 1.105 2.911 2.911 0 00-1.095-3.533 2.907 2.907 0 00-3.676.398l-5.307-3.063a2.606 2.606 0 000-1.52l5.3-3.034a2.907 2.907 0 003.682.405A2.911 2.911 0 0016.51 3.06a2.91 2.91 0 00-2.327 2.885c.008.247.047.491.117.728L8.992 9.735a2.907 2.907 0 00-2.079-.88z",
  fill: "#6373A4",
  fillRule: "nonzero"
}));

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgShare;